<template>
    <div>
        <b-modal v-model="showFacultyModal" title="Faculties" hide-footer>
            <b-form @submit.prevent="saveFaculties">

                <b-form-group>
                    <multiselect v-model="selectedFaculties" placeholder="Choose faculties" track-by="id"
                        :options="facultyOptions" :close-on-select="false" :multiple="true" :taggable="false"
                        :custom-label="facultyLabel" />
                </b-form-group>


                <!-- Already added faculties -->
                <div v-if="addedFaculties.length" class="mt-2">
                    <strong>Added Faculties</strong>
                    <ul class="list-group mt-1">
                        <li v-for="(faculty, i) in addedFaculties" :key="faculty.id"
                            class="list-group-item d-flex justify-content-between">
                            {{ faculty.first_name || null }} {{ faculty.last_name || null }}
                            <i class="fas fa-trash text-danger" style="cursor:pointer"
                                @click="removeFaculty(faculty.id, i)"></i>
                        </li>
                    </ul>
                </div>

                <!-- INLINE FACULTY DELETE CONFIRMATION -->
                <div v-if="showFacultyErrorModal" class="border rounded p-3 mt-3 bg-light">
                    <p class="text-danger mb-2">
                        {{ errorMessage }}
                    </p>

                    <p class="mb-1">
                        If you want to delete it, type <strong>DELETE</strong> and click Delete.
                    </p>

                    <b-form-input
                        v-model="deleteInput"
                        placeholder="Type DELETE to confirm"
                        class="mt-2"
                    />

                    <div class="text-right mt-3">
                        <b-button
                            variant="secondary"
                            size="sm"
                            @click="cancelFacultyDelete"
                        >
                            Cancel
                        </b-button>

                        <b-button
                            variant="danger"
                            size="sm"
                            class="ml-2"
                            :disabled="deleteInput !== 'DELETE'"
                            @click="confirmFacultyDelete"
                        >
                            Delete
                        </b-button>
                    </div>
                </div>

                <div class="d-flex justify-content-between mt-3">
                    <b-button v-if="selectedFaculties.length" variant="primary" size="sm" type="submit">
                        Save
                    </b-button>

                    <b-button variant="danger" size="sm" @click="closeFacultyModal">
                        Cancel
                    </b-button>
                </div>
            </b-form>
        </b-modal>


        <b-modal v-model="showEvaluationRoleModal" title="Evaluation Roles" hide-footer>
            <!-- Role list -->
            <div v-for="(role, i) in evaluationRoleInputs" :key="i" class="mb-2 d-flex align-items-center">
                <b-form-input
                    v-model="role.role_name"
                    placeholder="Enter evaluation role"
                />
                <b-button
                    variant="danger"
                    size="sm"
                    class="ml-2"
                    @click="removeRole(role.id, i)"
                >
                    ✕
                </b-button>
            </div>

            <b-button variant="link" @click="addRole">+ Add Role</b-button>

            <!-- INLINE DELETE CONFIRMATION (NO MODAL) -->
            <div v-if="showRoleErrorModal" class="border rounded p-3 mt-3 bg-light">
                <p class="text-danger mb-2">
                    {{ errorMessage }}
                </p>

                <p class="mb-1">
                    If you want to delete it, type <strong>DELETE</strong> and click Delete.
                </p>

                <b-form-input
                    v-model="deleteInput"
                    placeholder="Type DELETE to confirm"
                    class="mt-2"
                />

                <div class="text-right mt-3">
                    <b-button
                        variant="secondary"
                        size="sm"
                        @click="cancelRoleDelete"
                    >
                        Cancel
                    </b-button>

                    <b-button
                        variant="danger"
                        size="sm"
                        class="ml-2"
                        :disabled="deleteInput !== 'DELETE'"
                        @click="confirmRoleDelete"
                    >
                        Delete
                    </b-button>
                </div>
            </div>

            <!-- Footer buttons -->
            <div class="text-right mt-3">
                <b-button variant="primary" @click="submitEvaluationRoles">
                    Submit
                </b-button>
                <b-button variant="secondary" class="ml-2" @click="closeEvaluationRoleModal">
                    Cancel
                </b-button>
            </div>
        </b-modal>



        <b-modal id="errorModal" title="Delete Confirmation" v-model="showErrorModal">
            <p class="text-danger">{{ errorMessage }}</p>
            <p>If you want to delete it, type <strong>DELETE</strong> and click Delete.</p>

            <b-form-input v-model="deleteInput" placeholder="Type DELETE to confirm" class="mt-2"></b-form-input>

            <template #modal-footer>
                <b-button variant="secondary" @click="showErrorModal = false">Cancel</b-button>
                <b-button variant="danger" :disabled="deleteInput !== 'DELETE'"
                    @click="deleteProjectMethod(deleteIndex, deleteId, true)">
                    Delete
                </b-button>
            </template>
        </b-modal>

        <b-modal id="errorModal" title="Delete Confirmation" v-model="showParameterErrorModal">
            <p class="text-danger">{{ errorMessage }}</p>
            <p>If you want to delete it, type <strong>DELETE</strong> and click Delete.</p>

            <b-form-input v-model="deleteInput" placeholder="Type DELETE to confirm" class="mt-2"></b-form-input>

            <template #modal-footer>
                <b-button variant="secondary" @click="showParameterErrorModal = false">Cancel</b-button>
                <b-button variant="danger" :disabled="deleteInput !== 'DELETE'"
                    @click="deleteParameter(deleteId, deleteIndex, deleteMethodIndex, true)">
                    Delete
                </b-button>
            </template>
        </b-modal>

        <div class="loading" v-if="fetchData">
            <load-data></load-data>
        </div>


        <b-col class="addLab m-2">
            <b-card class="text-center mt-2">
                <!-- Button to add a new method -->
                <div class="d-flex justify-content-between align-items-center mt-2">
                    <!-- Left: Add Method Button -->
                    <b-button variant="info" @click="addMethod" class="d-flex align-items-center">
                        <i class="fas fa-plus-square text-white mr-2" style="font-size: 18px;"></i>
                        Add evaluation type for project evaluation
                    </b-button>
                </div> <br>

                <table class="table table-striped table-bordered">
                    <thead class="thead-dark text-left">
                        <tr>
                            <th style="width: 5px;">SI. No.</th>
                            <th>Type</th>
                            <th>Evaluation Role Name</th>
                            <th>Faculties</th>
                            <th></th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody class="text-left">
                        <template v-for="(method, index) in evaluationMethods">
                            <!-- Method Row -->
                            <tr :key="`method-${method.id || index}`"
                                v-if="methodExpandable === null || methodExpandable === method.id">
                                <td>{{ index + 1 }}</td>
                                <td>
                                    <span v-if="method.saved">{{ method.name }}</span>
                                    <div v-else class="d-flex flex-column">
                                        <b-form-input :ref="'input' + index" v-model="method.name"
                                            :class="{ 'form-group-error': $v.evaluationMethods.$each[index].name.$error }"
                                            placeholder="Enter type" style="width: 400px;"
                                            @blur="$v.evaluationMethods.$each[index].name.$touch()"></b-form-input>
                                        <span class="input-error-message"
                                            v-if="$v.evaluationMethods.$each[index].name.$error && $v.evaluationMethods.$each[index].name.$dirty">
                                            Type is required!
                                        </span>
                                    </div>
                                </td>

                                <td>
                                    <span v-if="method.id">
                                        <span v-if="!method.roles || !method.roles.length" class="text-danger"
                                            style="cursor:pointer" @click="openEvaluationRoleModal(method, index)">
                                            Not updated
                                        </span>

                                        <span
                                            v-else
                                            class="text-primary"
                                            style="cursor: pointer"
                                            @click="openEvaluationRoleModal(method, index)"
                                            >
                                            <span
                                                v-for="(role, rIndex) in method.roles"
                                                :key="rIndex"
                                                class="d-block"
                                            >
                                                {{ role.role_name }}
                                            </span> 
                                        </span>
                                        
                                    </span>

                                </td>


                                <td>
                                    <span v-if="method.roles && method.roles.length > 0">
                                        <div v-for="role in method.roles" :key="role.id">
                                            <!-- <strong>{{ role.role_name }}</strong> : -->
                                            <span v-if="!role.faculties.length" class="text-danger"
                                                style="cursor:pointer" @click="openFacultyModal(method, role)">
                                                Not updated
                                            </span>

                                            <span v-else class="text-primary" style="cursor:pointer"
                                                @click="openFacultyModal(method, role)">
                                                {{ role.faculties[0].first_name || null }} {{
                                                    role.faculties[0].last_name
                                                || null}}
                                                <span v-if="role.faculties.length > 1">
                                                    + {{ role.faculties.length - 1 }} others
                                                </span>
                                               
                                            </span>
                                            
                                        </div>
                                    </span>
                                </td>


                                <td>
                                    <b-button v-if="method.saved && method.id" variant="link" class="ml-2"
                                        @click="toggleParameterList(index, method)">
                                        <i style="font-size: 12px!important; cursor: pointer;"
                                            :class="method.showParameters ? 'fas fa-minus text-danger' : 'fas fa-plus text-success'"></i>
                                        List of Parameters
                                    </b-button>
                                </td>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <b-button v-if="!method.saved" variant="success" size="sm" class="mr-2"
                                            @click="saveProjectMethod(index)">
                                            {{ method.id ? 'Update' : 'Save' }}
                                        </b-button>
                                        <b-button v-if="!method.saved" variant="danger" size="sm" class="mr-2"
                                            @click="cancelProjectMethod(index, method.id)">
                                            Cancel
                                        </b-button>
                                        <i v-if="method.saved && method.id" class="far fa-edit text-info mr-2"
                                            style="font-size: 14px; cursor: pointer;"
                                            @click="editProjectMethod(index)"></i>
                                        <i v-if="method.saved && method.id" class="fas fa-trash text-danger"
                                            style="font-size: 14px; cursor: pointer;"
                                            @click="deleteProjectMethod(index, method.id)"></i>
                                    </div>
                                </td>
                            </tr>

                            <!-- Parameters Row -->
                            <tr v-if="method.showParameters && (methodExpandable === null || methodExpandable === method.id)"
                                :key="`param-${method.id || index}`">
                                <td colspan="4">
                                    <ProjectMethodParameters :method="method" :methodIndex="index"
                                        :courseOutcomeOptions="courseOutcomeOptions" @saveParameter="saveParameter"
                                        @cancelParameter="cancelParameter" @deleteParameter="deleteParameter"
                                        @addParameter="addParameter" :validation="$v.evaluationMethods.$each[index]" />
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

            </b-card>
        </b-col>
    </div>
</template>

<script>
import axios from "axios";

import { required, helpers } from "vuelidate/lib/validators";
import ProjectMethodParameters from './ProjectMethodParameters.vue';
const decimalNumeric = helpers.regex('decimalNumeric', /^\d*(\.\d+)?$/);

export default {
    components: {
        ProjectMethodParameters,
    },
    props: ["course_id"], // course_id passed as prop
    data() {
        return {
            showFacultyModal: false,
            selectedFaculties: [],
            addedFaculties: [],
            evaluationRoleInputs: [],
            facultyOptions: [], // [{ value:id, text:name }]
            showEvaluationRoleModal: false,
            evaluationRoleInput: '',
            selectedMethodIndex: null,
            selectedMethodId: null,
            viewImportExcelModel: false,
            importExcelFile: null,
            excelImportStatus: "",
            fetchData: false, // Loading state
            evaluationMethods: [], // Store evaluation methods
            methodExpandable: null, // Track which method's parameters to show
            courseOutcomeOptions: [], // Store available course outcomes
            evaluationTableHeaderRow: [],
            evaluationTableData: {},
            students: [],
            totalScores: {}, // processed on updateTotalMarks computed proprty
            avarage: {},
            updateProjectEvaluationButton: "Save",
            errorMessage: '',
            showErrorModal: false,
            showRoleErrorModal: false,
            showFacultyErrorModal: false,
            showParameterErrorModal: false,
            deleteInput: '',
            deleteFacultyId: null,
            deleteFacultyIndex: null,
            deleteId: null,
            deleteIndex: null,
            deleteMethodIndex: null,
        };
    },
    computed: {
        filteredEvaluationMethods() {
            return this.evaluationMethods.filter(
                method => this.methodExpandable === null || this.methodExpandable === method.id
            );
        },
        hasMethodWithParameters() {
            return this.evaluationMethods.some(method => method.parameters && method.parameters.length > 0);
        },
        allMethodsSaved() {
            return this.evaluationMethods.every(method => method.saved);
        }
    },
    validations: {
        evaluationMethods: {
            $each: {
                name: { required },
                parameters: {
                    $each: {
                        name: { required },
                        short_code: { required },
                        maximum_score: {
                            required,
                            decimalNumeric
                        }
                    }
                },
            }
        }
    },

    async created() {
        await Promise.all([
            this.fetchProjectMethods(),
            this.getcourseOutcomes(),
            this.getInstitutionFaculties()
        ]);
    },

    methods: {
        // Fetch course outcomes for the given course
        async getcourseOutcomes() {
            const courseOutcomeUrl = this.$store.getters.getAPIKey.getCourseOutcomes;
            const url = courseOutcomeUrl.replace("course_id", this.course_id);
            await axios.get(url)
                .then((response) => {
                    response.data.forEach(co => {
                        this.courseOutcomeOptions.push({ value: co.id, text: co.code });
                    });
                })
                .catch(error => {
                    error;
                });
        },

        openFacultyModal(method, role) {
            this.selectedMethodIndex = this.evaluationMethods.indexOf(method)
            this.selectedRoleId = role.id
            this.selectedFaculties = []
            this.addedFaculties = role.faculties ? [...role.faculties] : []
            this.showFacultyModal = true
        },


        async saveFaculties() {
            try {
                await axios.post(
                    `${this.$store.getters.getAPIKey.mainAPI}/projectmethods/faculties`,
                    {
                        project_role_id: this.selectedRoleId,
                        faculty_ids: this.selectedFaculties.map(f => f.id)
                    }
                )

                const role = this.findRoleById(this.selectedRoleId)
                role.faculties = [...this.addedFaculties, ...this.selectedFaculties]
                this.$emit('methods-updated')
                this.fetchProjectMethods();
                this.$toast.success('Faculties updated successfully')
                this.closeFacultyModal()

            } catch {
                this.$toast.error('Failed to save faculties')
            }
        },

        findRoleById(roleId) {
            for (const method of this.evaluationMethods) {
                const role = method.roles.find(r => r.id === roleId)
                if (role) return role
            }
        },

        async removeFaculty(facultyId, index, forceDelete = false) {
            try {
                let url = `${this.$store.getters.getAPIKey.mainAPI}/projectmethods/faculties/${facultyId}`
                if (forceDelete) {
                    url += '?forceDelete=1'
                }

                const response = await axios.delete(url, {
                    data: { project_role_id: this.selectedRoleId }
                })

                if (response.data === 1) {
                    this.addedFaculties.splice(index, 1)
                    const role = this.findRoleById(this.selectedRoleId)
                    if (role) {
                        role.faculties = [...this.addedFaculties]
                    }
                    this.showFacultyErrorModal = false
                    this.$emit('methods-updated')
                    this.fetchProjectMethods()
                    this.$toast.success('Faculty removed')
                } else {
                    this.errorMessage = 'Cannot delete — this Faculty has evaluations mapped.'
                    this.deleteFacultyId = facultyId
                    this.deleteFacultyIndex = index
                    this.deleteInput = ''
                    this.showFacultyErrorModal = true
                }
            } catch {
                this.$toast.error('Failed to remove faculty')
            }
        },

        cancelFacultyDelete() {
            this.showFacultyErrorModal = false
            this.deleteInput = ''
            this.deleteFacultyId = null
            this.deleteFacultyIndex = null
        },

        async confirmFacultyDelete() {
            if (this.deleteInput !== 'DELETE') return
            await this.removeFaculty(this.deleteFacultyId, this.deleteFacultyIndex, true)
            this.showFacultyErrorModal = false
            this.deleteInput = ''
        },

        facultyLabel(faculty) {
            if (!faculty) return ''
            return `${faculty.first_name || ''} ${faculty.last_name || ''} (${faculty.email || ''})`
                .replace(/\s+/g, ' ')
                .trim()
        },

        async getInstitutionFaculties() {
            const url = this.$store.getters.getAPIKey.instituitionFaculty
            try {
                const response = await axios.get(url)
                this.facultyOptions = response.data
            } catch (e) {
                // handle error
            }
        },

        closeFacultyModal() {
            this.showFacultyModal = false
            this.selectedFacultyIds = []
            this.addedFaculties = []
            this.selectedMethodId = null
        },

        openEvaluationRoleModal(method, index) {
            this.selectedMethodIndex = index
            this.selectedMethodId = method.id

            this.evaluationRoleInputs = (method.roles || []).length
                ? method.roles.map(r => ({
                    id: r.id,
                    role_name: r.role_name || ''
                }))
                : [{ id: null, role_name: '' }]
            this.showRoleErrorModal = false
            this.showEvaluationRoleModal = true
        },


        addRole() {
            this.evaluationRoleInputs.push({ id: null, role_name: '' })
        },

        cancelRoleDelete() {
            this.showRoleErrorModal = false
            this.deleteInput = ''
            this.deleteId = null
            this.deleteIndex = null
        },

        async confirmRoleDelete() {
            if (this.deleteInput !== 'DELETE') return

            await this.removeRole(this.deleteId, this.deleteIndex, true)

            this.showRoleErrorModal = false
            this.deleteInput = ''
        },

        async removeRole(roleId, index, forceDelete = false) {
            // New role → remove locally
            if (!roleId) {
                this.evaluationRoleInputs.splice(index, 1)
                return
            }

            try {
                let url = `${this.$store.getters.getAPIKey.mainAPI}/projectmethods/roles/${roleId}`
                if (forceDelete) {
                    url += '?forceDelete=1'
                }

                const response = await axios.delete(url)

                if (response.data === 1) {
                    this.evaluationRoleInputs.splice(index, 1)
                    this.fetchProjectMethods()
                    this.$toast.success('Successfully Deleted')
                } else {
                    this.errorMessage = 'Cannot delete — this Role is mapped to Faculties/Update Score.'
                    this.deleteId = roleId
                    this.deleteIndex = index
                    this.deleteInput = ''
                    this.showRoleErrorModal = true
                }
            } catch (e) {
                this.$toast.error('Failed to delete role')
            }
        },


        closeEvaluationRoleModal() {
            this.showEvaluationRoleModal = false
            this.evaluationRoleInputs = []
            this.selectedMethodIndex = null
            this.showRoleErrorModal = true;
        },

        async submitEvaluationRoles() {
            try {
                const roles = this.evaluationRoleInputs
                    .map(r => ({
                        id: r.id || null,
                        role_name: r.role_name?.trim()
                    }))
                    .filter(r => r.role_name)

                if (!roles.length) {
                    this.$toast.error('Please add at least one role')
                    return
                }

                await axios.post(
                    `${this.$store.getters.getAPIKey.mainAPI}/projectmethods/roles`,
                    {
                        project_method_id: this.selectedMethodId,
                        roles
                    }
                )

                await this.fetchProjectMethods()
                this.$toast.success('Evaluation roles updated successfully')
                this.closeEvaluationRoleModal()

            } catch (e) {
                console.error(e)
                this.$toast.error('Failed to save evaluation roles')
            }
        },







        CloseProjectEvaluationModel() {
            this.$bvModal.hide("projectEvaluationModel");
        },


        // Fetch saved project evaluation methods from the API
        async fetchProjectMethods() {
            this.fetchData = true;
            const url = `${this.$store.getters.getAPIKey.mainAPI}/projectmethods?course_id=${this.course_id}`;

            try {
                const response = await axios.get(url);
                this.methodExpandable = null;
                this.evaluationMethods = response.data.map((method) => ({
                    id: method.id,
                    name: method.name,
                    // faculties: method.faculties,
                    roles: method.roles,
                    // evaluation_role: method.evaluation_role,
                    parameters: method.project_parameters ?? [],
                    saved: true,
                    showParameters: false, // Initialize with hidden parameters
                }));
            } catch (error) {
                this.$toast.error("Failed to fetch evaluation methods", { position: "top", duration: 3000 });
            } finally {
                this.fetchData = false;
            }
        },

        // Add a new evaluation method
        addMethod() {
            this.methodExpandable = null;
            this.evaluationMethods.forEach(method => {
                method.showParameters = false;
            });
            const newIndex = this.evaluationMethods.length;
            this.evaluationMethods.push({ name: "", saved: false, id: null, showParameters: false, parameters: [] });
            this.$nextTick(() => {
                const inputRef = this.$refs['input' + newIndex];
                if (inputRef && inputRef[0]) {
                    inputRef[0].focus();
                }
            });
        },

        // Save or update an evaluation method
        async saveProjectMethod(index) {
            this.$v.evaluationMethods.$each[index].name.$touch();
            if (this.$v.evaluationMethods.$each[index].name.$invalid) {
                return;
            }

            this.fetchData = true;
            const method = this.evaluationMethods[index];

            const url = `${this.$store.getters.getAPIKey.mainAPI}/projectmethods${method.id ? '/' + method.id : ''}`;
            const requestType = method.id ? 'put' : 'post';

            try {
                const response = await axios[requestType](url, {
                    course_id: this.course_id,
                    name: method.name,
                    roles: method.roles?.map(r => r.role_name)
                });

                if (!method.id) {
                    this.evaluationMethods[index].id = response.data.id;
                }

                this.evaluationMethods[index].saved = true;
                this.$emit('methods-updvated');
                this.fetchProjectMethods();
                this.$toast.success(
                    method.id ? "Updated successfully" : "Saved successfully",
                    { position: "top", duration: 3000 }
                );

            } catch (error) {
                this.$toast.error(
                    "Failed to save method, please try again",
                    { position: "top", duration: 3000 }
                );
            } finally {
                this.fetchData = false;
            }
        },

        // Edit an existing method (set to unsaved)
        editProjectMethod(index) {
            const method = this.evaluationMethods[index];

            method._original = {
                name: method.name,
            };

            method.saved = false;

            this.$nextTick(() => {
                const inputRef = this.$refs['input' + index];
                if (inputRef && inputRef[0]) {
                    inputRef[0].focus();
                }
            });
        },
        cancelProjectMethod(index, methodId) {
            const method = this.evaluationMethods[index];

            // Reset validation state
            this.$v.evaluationMethods.$each[index].name.$reset();

            if (methodId) {
                if (method._original) {
                    method.name = method._original.name;
                    delete method._original;
                }
                method.saved = true;
            } else {
                // If it's a newly added method, just remove it
                this.evaluationMethods.splice(index, 1);
            }
        },
        cancelParameter(methodIndex, parameterIndex, parameterId) {
            this.$v.evaluationMethods.$each[methodIndex].parameters.$each[parameterIndex].$reset();
            const parameter = this.evaluationMethods[methodIndex].parameters[parameterIndex];

            if (parameterId) {
                // Restore original values
                if (parameter._original) {
                    parameter.serial_number = parameter._original.serial_number;
                    parameter.name = parameter._original.name;
                    parameter.short_code = parameter._original.short_code;
                    parameter.maximum_score = parameter._original.maximum_score;
                    parameter.cos = [...parameter._original.cos];
                    delete parameter._original;
                }
                parameter.isEditing = false;
            } else {
                // Remove unsaved parameter
                this.evaluationMethods[methodIndex].parameters.splice(parameterIndex, 1);
            }
        },
        async deleteProjectMethod(index, id, forceDelete = false) {
            this.methodExpandable = null;
            this.evaluationMethods[index].showParameters = false;
            this.fetchData = true;

            let url = `${this.$store.getters.getAPIKey.mainAPI}/projectmethods/${id}`;
            if (forceDelete) {
                url += '?forceDelete=1';
            }

            try {
                const response = await axios.delete(url);
                if (response.data === 1) {
                    this.evaluationMethods.splice(index, 1);
                    this.showErrorModal = false;
                    this.$emit('methods-updated');
                    this.$toast.success('Successfully Deleted', {
                        position: "top",
                        duration: 3000,
                    });
                } else {
                    this.errorMessage = "Cannot delete — this method is mapped to parameters, evaluation roles, and their faculties.";
                    this.deleteId = id;
                    this.deleteIndex = index;
                    this.deleteInput = '';
                    this.showErrorModal = true;
                }

            } catch (error) {
                error;

            } finally {
                this.fetchData = false;
            }
        },

        // Toggle the visibility of parameters
        toggleParameterList(index, method) {
            this.methodExpandable = this.methodExpandable === method.id ? null : method.id;
            method.showParameters = !method.showParameters;
            if (!method.showParameters) {
                this.fetchProjectMethods()
            }
        },
        addParameter(index) {
            this.evaluationMethods[index].parameters.push({
                serial_number: null,
                name: "",
                short_code: "",
                isEditing: false
            });
        },

        // Save or update a parameter for a method
        async saveParameter(methodIndex, paramIndex) {
            const validationParam = this.$v.evaluationMethods.$each[methodIndex].parameters.$each[paramIndex];

            // Touch both fields to show validation messages
            validationParam.name.$touch();
            validationParam.short_code.$touch();
            validationParam.maximum_score.$touch();

            if (validationParam.name.$invalid || validationParam.short_code.$invalid || validationParam.maximum_score.$invalid) {
                return;
            }
            this.fetchData = true;
            const method = this.evaluationMethods[methodIndex];
            const parameter = method.parameters[paramIndex];
            const url = `${this.$store.getters.getAPIKey.mainAPI}/projectparameters${parameter.id ? '/' + parameter.id : ''}`;
            const requestType = parameter.id ? 'put' : 'post';

            try {
                const response = await axios[requestType](url, {
                    project_method_id: method.id,
                    serial_number: parameter.serial_number,
                    name: parameter.name,
                    short_code: parameter.short_code,
                    maximum_score: parameter.maximum_score,
                    cos: parameter.cos,
                });
                this.evaluationMethods[methodIndex].parameters[paramIndex].isEditing = false;
                this.evaluationMethods[methodIndex].parameters[paramIndex].id = response.data.id;
                this.evaluationMethods[methodIndex].parameters[paramIndex].co_codes = response.data.course_outcomes.map((co) => co.code);
                method.parameters.sort((a, b) => (a.serial_number || 0) - (b.serial_number || 0));
                this.$toast.success(parameter.id ? "Parameter updated successfully" : "Parameter saved successfully", { position: "top", duration: 3000 });
            } catch (error) {
                this.$toast.error("Failed to save parameter", { position: "top", duration: 3000 });
            } finally {
                this.fetchData = false;
            }
        },

        // Delete a parameter
        async deleteParameter(paramId, paramIndex, methodIndex, forceDelete = false) {
            if (!paramId) return;

            this.fetchData = true;

            let url = `${this.$store.getters.getAPIKey.mainAPI}/projectparameters/${paramId}`;
            if (forceDelete) {
                url += '?forceDelete=1';
            }

            try {
                const response = await axios.delete(url);

                if (response.data === 1) {
                    this.evaluationMethods[methodIndex].parameters.splice(paramIndex, 1);
                    this.showParameterErrorModal = false;
                    this.$toast.success('Successfully Deleted', {
                        position: "top",
                        duration: 3000,
                    });
                } else {
                    this.errorMessage = "Cannot delete — this parameter is mapped to a score update.";
                    this.deleteId = paramId;
                    this.deleteIndex = paramIndex;
                    this.deleteMethodIndex = methodIndex;
                    this.deleteInput = '';
                    this.showParameterErrorModal = true;
                }

            } catch (error) {
                if (error.response && error.response.data && error.response.data.message) {
                    this.$toast.error(error.response.data.message, { position: "top", duration: 3000 });
                } else {
                    this.$toast.error("Failed to delete parameter", { position: "top", duration: 3000 });
                }
            } finally {
                this.fetchData = false;
            }
        },
    }
}
</script>
